import React from 'react';
import { Layout, Card, Typography, Row, Col, Tag, Space, Button } from 'antd';
import { CalendarOutlined, UserOutlined, LoginOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import PublicNavigation from '../components/PublicNavigation.jsx';

const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;

const News = () => {
  const navigate = useNavigate();
  
  // Пример новостей - в реальном проекте это будет загружаться с API
  const news = [
    {
      id: 1,
      title: 'Новая система защиты от подделок',
      excerpt: 'Мы внедрили передовые технологии для защиты ваших товаров от подделок...',
      content: 'Подробное описание новой системы защиты...',
      date: '2024-01-15',
      author: 'Администратор',
      category: 'Технологии'
    },
    {
      id: 2,
      title: 'Обновление мобильного приложения',
      excerpt: 'Вышла новая версия мобильного приложения с улучшенным интерфейсом...',
      content: 'Подробное описание обновлений...',
      date: '2024-01-10',
      author: 'Разработчики',
      category: 'Обновления'
    },
    {
      id: 3,
      title: 'Партнерство с ведущими брендами',
      excerpt: 'Мы заключили партнерские соглашения с крупнейшими производителями...',
      content: 'Подробная информация о партнерстве...',
      date: '2024-01-05',
      author: 'Менеджмент',
      category: 'Партнерство'
    }
  ];

  const getCategoryColor = (category) => {
    const colors = {
      'Технологии': 'blue',
      'Обновления': 'green',
      'Партнерство': 'orange'
    };
    return colors[category] || 'default';
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <PublicNavigation />
      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <Title level={1}>Новости</Title>
            <Text type="secondary" style={{ fontSize: '16px' }}>
              Последние обновления и события LimitVerify
            </Text>
          </div>

          <Row gutter={[24, 24]}>
            {news.map((item) => (
              <Col xs={24} md={12} lg={8} key={item.id}>
                <Card
                  hoverable
                  style={{ height: '100%' }}
                  bodyStyle={{ padding: '20px' }}
                >
                  <Space direction="vertical" size="small" style={{ width: '100%' }}>
                    <div>
                      <Tag color={getCategoryColor(item.category)}>
                        {item.category}
                      </Tag>
                    </div>
                    
                    <Title level={4} style={{ margin: 0 }}>
                      {item.title}
                    </Title>
                    
                    <Paragraph 
                      ellipsis={{ rows: 3 }}
                      style={{ margin: 0, color: '#666' }}
                    >
                      {item.excerpt}
                    </Paragraph>
                    
                    <Space size="small" style={{ marginTop: 'auto' }}>
                      <CalendarOutlined style={{ color: '#999' }} />
                      <Text type="secondary" style={{ fontSize: '12px' }}>
                        {new Date(item.date).toLocaleDateString('ru-RU')}
                      </Text>
                      <UserOutlined style={{ color: '#999', marginLeft: '8px' }} />
                      <Text type="secondary" style={{ fontSize: '12px' }}>
                        {item.author}
                      </Text>
                    </Space>
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default News;
